<template>
  <FimButton
    v-if="mainAction === 'addToBasket'"
    data-testid="add-to-cart"
    class="w-full"
    :disabled="disabled"
    @click="$emit('addToBasket')"
    @mousedown="(e) => trackButtonClick(e.target as HTMLButtonElement)"
  >
    <template #icon>
      <LazyIconFielmannReload v-if="editingGroupId" class="size-5" />
      <LazyIconFielmannCart v-else class="size-5" />
    </template>
    {{ label || $t('rxConfigurator.summary.add_to_basket') }}
  </FimButton>

  <FimButton
    v-else-if="mainAction === 'appointment'"
    data-testid="rx-schedule-appointment"
    class="w-full"
    :to="appointmentUrl"
    target="_blank"
    :disabled="disabled"
    :label="$t('rxConfigurator.appointment.title')"
    @mousedown="(e) => trackLinkClick(e.target as HTMLAnchorElement)"
  >
    <template #icon>
      <LazyIconFielmannStore class="size-5" />
    </template>
    {{ $t('rxConfigurator.appointment.button') }}
  </FimButton>

  <FimButton
    v-else-if="mainAction === 'check'"
    data-testid="rx-sight-prescription-check"
    data-tracking-label="Jetzt Seh-Check starten"
    class="w-full"
    :to="sightPrescriptionCheckUrl"
    target="_blank"
    :disabled="disabled"
    :label="$t('rxConfigurator.sightPrescriptionCheck.title')"
    @mousedown="(e) => trackLinkClick(e.target as HTMLAnchorElement)"
  >
    <template #icon>
      <LazyIconFielmannWebcam class="size-5" />
    </template>
    {{ $t(`rxConfigurator.sightPrescriptionCheck.button`) }}
  </FimButton>

  <FimButton
    v-else-if="mainAction === 'skipValues'"
    class="w-full"
    data-testid="rx-skip-values"
    type="secondary"
    :disabled="disabled"
    @mousedown="(e) => trackButtonClick(e.target as HTMLButtonElement)"
  >
    <slot>
      {{ label || $t(`rxConfigurator.skip_values`) }}
    </slot>
  </FimButton>

  <FimButton
    v-else
    class="w-full"
    data-testid="rx-next-step"
    :disabled="disabled"
    @click="$emit('step:next')"
    @mousedown="(e) => trackButtonClick(e.target as HTMLButtonElement)"
  >
    <slot>
      {{ label || $t(`rxConfigurator.continue`) }}
    </slot>
  </FimButton>
</template>

<script setup lang="ts">
defineProps({
  mainAction: {
    type: String as PropType<RxMainAction>,
    required: false,
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
  editingGroupId: {
    type: String as PropType<string>,
    default: undefined,
  },
})

const emit = defineEmits(['addToBasket', 'step:next'])

const $currentShop = useCurrentShop()
const { getAppointmentUrl } = await useAppointments()
const { trackButtonClick, trackLinkClick } = await useTrackingEvents()

const appointmentUrl = computed(() => getAppointmentUrl())
const sightPrescriptionCheckUrl = computed(
  () => $currentShop.value.sightPrescriptionCheckUrl,
)
</script>
